<template>
  <div class="app_wrapper" id="index">
    <nav-header />
    <float-nav />
    <app-main />
    <Loading v-if="isShowComponents" :isLoading="showLoading" />
    <nav-footer />
  </div>
</template>
<script>
import { onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import appMain from './components/appMain.vue'
import navHeader from './components/navHeader.vue'
import navFooter from './components/navFooter.vue'
import floatNav from './components/floatNav.vue'
import Loading from '../components/Loading.vue'
import { useStore } from 'vuex'
export default {
  name: 'Layout',
  components: {
    Loading,
    appMain,
    navHeader,
    navFooter,
    floatNav
  },
  setup () {
    const route = useRoute()
    const store = useStore()
    const floatNavShow = ref(false)
    const showLoading = ref(false)
    const isShowComponents = ref(true) // 控制显示组件

    const closeCustom = ref(false)

    // watch(() => route.path, (path) => {
    //   if (path.startsWith('/home')) {
    //     floatNavShow.value = true
    //   } else {
    //     floatNavShow.value = false
    //   }
    // })
    watch(
      () => store.state.isCustomCustomer,
      (newVal) => {
        closeCustom.value = newVal
      }
    )

    watch(
      () => store.state.loading,
      (newVal) => {
        showLoading.value = newVal
      }
    )
    onMounted(() => {
      if (route.path === '/home') {
        floatNavShow.value = true
      }
    })
    return {
      showLoading,
      isShowComponents,
      floatNavShow
    }
  }
}
</script>
<style lang="scss" scoped>
.app_wrapper {
  position: relative;
}
</style>
